import Image from 'next/image';
import { useTranslation } from 'react-i18next';

const Loader = () => {
  const { t } = useTranslation();
  return (
    <div className="payment-loader-animation">
      <Image height={40} width={50} alt={t('common.loading')} src="/loading-part-1.svg" />
      <Image height={40} width={50} alt={t('common.loading')} src="/loading-part-2.svg" />
    </div>
  );
};

export default Loader;
